import * as React from "react";
import useSendTelemetry from "./useSendTelemetry";
const withTelemetry = (Component, appSection) => function WrappedComponent(props) {
  const sendTelemetry = useSendTelemetry(appSection);
  return /* @__PURE__ */ React.createElement(Component, { ...props, sendTelemetry });
};
export default withTelemetry;
